import React, { useState } from 'react';

import Layout from '../components/layout';
import SEO from '../components/seo';

import Hero from '../components/sections/hero/hero';
import Flowchart from '../components/sections/flowchart/flowchart';
import Mission from '../components/sections/mission/mission';
import Reviews from '../components/sections/reviews/reviews';
import Team from '../components/sections/team/team';
import History from '../components/sections/history/history';
import Features from '../components/sections/features/features';
import MyModal from '../components/elements/modal';

import '../styles/index.scss';

const IndexPage = () => {
	const [modalShow, setModalShow] = useState(false);
	const [modalText, setModalText] = useState('demo');
	function openModal(modalType) {
		if (modalType === 'demo') {
			setModalText('demo');
		}
		if (modalType === 'kontakt') {
			setModalText('kontakt');
		}
		console.log(modalType);
		setModalShow(true);
	}
	return (
		<Layout openModal={openModal}>
			<SEO title='Ihr digitaler Assistent' />
			<MyModal
				modaltext={modalText}
				show={modalShow}
				onHide={() => setModalShow(false)}
			/>
			<Hero openModal={openModal} />
			<Flowchart />
			<Mission />
			<Reviews />
			<Team />
			<History />
			<Features />
		</Layout>
	);
};

export default IndexPage;
